import Header from "components/Header/Header";
import { WEB_STORAGE_KEYS } from "constants/webStorageKey";
import { RoutePath } from "data/router/paths";
import useCustomNavigate from "hooks/common/useCustomNavigate";
import ScrollToTop from "hooks/common/useScrollTop";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { authStore } from "stores/auth-stores";
import { getSessionStorage } from "utils/webStorage-utils";
import styles from "./Layout.module.scss";
import Loading from "components/loading/loading";
import { commonStore } from "stores/common-stores";

export default function Layout() {
  const [isAuth, setIsAuth] = useState(false);
  const { loginStatus } = authStore();
  const { isLoading } = commonStore();

  const { navigateToReplacePath } = useCustomNavigate();

  useEffect(() => {
    const isLogin = getSessionStorage(WEB_STORAGE_KEYS.LOGIN_STATUS) as boolean;
    setIsAuth(isLogin);
    if (!isLogin) {
      navigateToReplacePath(RoutePath.login);
    }
  }, [loginStatus]);

  return (
    <>
      {isAuth ? (
        <div className={styles["layout__container"]}>
          <ScrollToTop />
          <Header />
          <div className={styles["body__wrap"]}>
            <Outlet></Outlet>
          </div>
        </div>
      ) : (
        <></>
      )}
      {isLoading && <Loading />}
    </>
  );
}
